var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_vm._m(0),_c('p',{staticClass:"warn"},[_vm._v("补充资料")]),_c('div',{staticClass:"tip"},[_c('p',{staticClass:"text"},[_vm._v("您有待补充的资料，请尽快完成。")]),_c('p',{staticClass:"text"},[_vm._v("详情："+_vm._s(_vm.orderInfo.refuseInfo))])])])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"mark"},[_c('img',{staticClass:"QRcodeIcon",attrs:{"src":require("@/assets/images/exclamatoryMark.png"),"alt":""}})])
}]

export { render, staticRenderFns }